import { render } from "./menu.vue?vue&type=template&id=b6e0702e&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=b6e0702e&lang=scss&scoped=true"
import "./menu.vue?vue&type=style&index=1&id=b6e0702e&lang=scss"
script.render = render
script.__scopeId = "data-v-b6e0702e"

export default script